import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=2eb312df&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eb312df')) {
      api.createRecord('2eb312df', component.options)
    } else {
      api.reload('2eb312df', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=2eb312df&", function () {
      api.rerender('2eb312df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KXMEmhPpqR6W/JS/comp/childrenage.vue"
export default component.exports